import ProfileIcon from '@repo/ui/components/Icon/ProfileIcon';
import SettingsIcon from '@repo/ui/components/Icon/SettingsIcon';
import StarIcon from '@repo/ui/components/Icon/StarIcon';

import { Option } from '../../MultiOption/types';

export const options: Record<string, Option> = {
  Profile: {
    label: 'Profile & Projects',
    icon: ProfileIcon,
    url: '/user/dashboard',
  },
  AccountSettings: {
    label: 'Account Settings',
    teamLabel: 'Team Settings',
    icon: SettingsIcon,
    url: '/user/settings/account',
  },
  Subscription: {
    label: 'Subscription',
    icon: StarIcon,
    url: '/pricing',
  },
};
